<ng-container class="aboutWrapper">
    <p>about-me content here</p>
</ng-container>
